// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Carousel/Carousel.less
// module id = 192
// module chunks = 2